import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackNewShippingInfoSetParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/account/trackNewShippingInfoSet";

const useTrackNewShippingInfoSet = (
    parameters: TrackNewShippingInfoSetParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.newShippingInfoSet, parameters, options);
};

export default useTrackNewShippingInfoSet;
